import React, { useEffect } from 'react';
import { BrowserRouter } from 'react-router-dom';

import { useContentSquare } from '@virginmoney/content-square-tracking';
import GlobalErrorBoundary from './components/GlobalErrorBoundary/GlobalErrorBoundary';
import { StateContext } from './state/state-context';
import { useForm } from './hooks/useForm';
import { useContent } from './hooks/useContent';
import { useAdbobeTacking } from './hooks/useAdbobeTacking';
import { AppLayout } from 'components/Layout/AppLayout';
import { Router, getBasePath } from './routes';

import 'styles/materalize/materialize.scss';

export const App = () => {
  const form = useForm();
  const content = useContent();
  const basepath = getBasePath();
  const brand = basepath.substr(1);
  useContentSquare();
  useAdbobeTacking({ trackingId: '47fdeb0d63d5c3abcb126454f2de78828942a7b2' });

  return (
    <GlobalErrorBoundary>
      <StateContext.Provider value={{ form, content, brand: brand.toLowerCase() }}>
        <BrowserRouter basename={basepath}>
          <AppLayout>
            <Router />
          </AppLayout>
        </BrowserRouter>
      </StateContext.Provider>
    </GlobalErrorBoundary>
  );
};

export default App;
